export const REMOVE_CONTENT_PLATFORM_USER_HEADER = 'remove_content_platform_user_header';

export const InterceptorDebugFlags: { name: string }[] = [
  {
    name: REMOVE_CONTENT_PLATFORM_USER_HEADER
  }
];
